const normalizeImageSrc = (src) => {
  if (!src) return src;
  if (src.startsWith('//')) return window.location.protocol + src;
  if (src.startsWith('/')) return window.location.origin + src;
  return src;
};

export default normalizeImageSrc;
